<template>
	<div class="row">
		<div class="col-xs-12">
			<HeaderForm>{{ _traducao('global', 'trecho') }}</HeaderForm>
			<div v-for="(item, index) in form.trecho" :key="index">
				<div class="row">
					<div class="col-xs-12 text-center" style="padding-left: 50px">
						<i
							class="fa fa-chevron-down"
							style="color: #2196f3; font-size: 20px"
							v-show="index"
							aria-hidden="true"
						></i>
					</div>

					<div class="col-xs-12">
						<HeaderForm
							v-if="form.trecho[index].id != 0"
							:style="{
								marginLeft:
									form.trecho.length > 1 && !apenasExibicao ? '36px' : ''
							}"
						>
							<span> {{ _traducao('global', 'trecho') }} {{ index + 1 }} </span>
							<template #actions>
								<div>
									<ButtonTrash
										:disabled="disabled"
										v-show="index"
										@click="clickTrechoRemover(index)"
										>{{
											_traducao('menuEscala', 'menuRemover') | upper
										}}</ButtonTrash
									>
									<ButtonShare
										@click="redirectToRoute(item)"
										v-if="_getPrivilegio(408) && planejarRotas"
										>PLANEJAR ROTA</ButtonShare
									>
								</div>
							</template>
						</HeaderForm>
						<HeaderForm
							v-else-if="form.trecho[index].id == 0 && trechoMultiplo"
							:style="{
								marginLeft:
									form.trecho.length > 1 && !apenasExibicao ? '36px' : ''
							}"
						>
							<span> {{ _traducao('global', 'trecho') }} {{ index + 1 }} </span>
							<template #actions>
								<div>
									<ButtonTrash
										:disabled="disabled"
										v-show="index"
										@click="clickTrechoRemover(index)"
										>{{
											_traducao('menuEscala', 'menuRemover') | upper
										}}</ButtonTrash
									>
									<ButtonShare
										@click="redirectToRoute(item)"
										v-if="_getPrivilegio(408) && planejarRotas"
										>PLANEJAR ROTA</ButtonShare
									>
								</div>
							</template>
						</HeaderForm>
					</div>
				</div>

				<div>
					<div
						v-if="form.trecho.length > 1 && !apenasExibicao"
						style="
							width: 36px;
							float: left;
							display: flex;
							align-items: center;
							min-height: 350px;
						"
					>
						<div>
							<span class="pointer">
								<svg
									@click="clickMove('down', item, index)"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke-width="1.5"
									stroke="currentColor"
									style="width: 28px; color: rgb(33, 150, 243)"
									v-show="index != 0"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="m4.5 15.75 7.5-7.5 7.5 7.5"
									/>
								</svg>
							</span>
							<input
								type="text"
								:value="item.ordem"
								disabled="disabled"
								class="form-control text-center input-sm"
								style="display: none"
							/>
							<span class="pointer">
								<svg
									@click="clickMove('up', item, index)"
									v-show="!disabledDownButton(index)"
									xmlns="http://www.w3.org/2000/svg"
									fill="none"
									viewBox="0 0 24 24"
									stroke-width="1.5"
									stroke="currentColor"
									style="width: 28px; color: rgb(33, 150, 243)"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										d="m19.5 8.25-7.5 7.5-7.5-7.5"
									/>
								</svg>
							</span>
						</div>
					</div>
					<div
						:style="{
							width:
								form.trecho.length > 1 && !apenasExibicao
									? 'calc(100% - 36px)'
									: '100%'
						}"
						style="float: left"
					>
						<div class="row">
							<div class="col-xs-12 col-md-6">
								<div class="trecho-borda" style="min-height: 350px">
									<div class="text-center" style="margin-bottom: 20px">
										<span>{{
											_traducao('global', 'origem').toUpperCase()
										}}</span>
									</div>
									<div class="row">
										<div
											v-show="flagAvancado"
											class="col-xs-12 col-md-12 form-group"
											:class="{'has-error': item.erro_pais_partida != ''}"
										>
											<label>* {{  _traducao('global', 'pais') }} :</label>
											<v-select
												v-show="listaPaises.length"
												:options="listaPaises"
												v-model="item.pais_partida"
												:disabled="disabled"
												label="descricao"
												class="form-control input-sm"
												@input="
													carregaEstados(item, index, 'P', item.pais_partida)
												"
											></v-select>
											<flCarregando v-show="!listaPaises.length"></flCarregando>
											<p class="help-block" v-if="item.erro_pais_partida != ''">
												{{ item.erro_pais_partida }}
											</p>
										</div>

										<!-- ESTADO -->
										<div
											class="col-xs-12 col-md-6 form-group"
											:class="{'has-error': item.erro_estado_partida != ''}"
										>
											<label>
												<span>*</span>
												{{ _traducao('global', 'estado') }}:
											</label>
											<v-select
												:options="item.lista_estados_partida"
												label="nome"
												class="form-control input-sm"
												v-model="item.estado_partida"
												:disabled="disabled"
												@input="
													carregaCidades(item, index, 'P', item.estado_partida)
													$emit('trecho-alterado')
												"
												v-show="!item.loadEstadoPartida"
											></v-select>
											<p
												class="help-block"
												v-show="item.erro_estado_partida != ''"
											>
												{{ item.erro_estado_partida }}
											</p>
											<flCarregando
												v-show="item.loadEstadoPartida"
											></flCarregando>
										</div>

										<!-- CIDADE -->
										<div
											class="col-xs-12 col-md-6 form-group"
											:class="{'has-error': item.erro_cidade_partida != ''}"
										>
											<label>
												<span>*</span>
												{{ _traducao('global', 'cidade') }}:
											</label>
											<v-select
												:options="item.lista_cidades_partida"
												label="descricao"
												class="form-control input-sm"
												v-model="item.cidade_partida"
												:disabled="disabled"
												@input="
													carregaAeroporto(
														item,
														index,
														'P',
														item.cidade_partida
													)
													$emit('trecho-alterado')
												"
												v-show="!item.loadCidadePartida"
											></v-select>
											<p
												class="help-block"
												v-show="item.erro_cidade_partida != ''"
											>
												{{ item.erro_cidade_partida }}
											</p>
											<flCarregando
												v-show="item.loadCidadePartida"
											></flCarregando>
										</div>
									</div>

									<div class="row">
										<!-- DESIGNATIVO -->
										<div
											class="col-xs-12 form-group"
											:class="{
												'has-error': item.erro_designativo_partida != ''
											}"
										>
											<label>* {{ _traducao('global', 'aeroporto') }}:</label>
											<select-items
												@select="
													(rotaer) => {
														item.designativo_partida = rotaer ? rotaer : null
														calculaFuso(index, form.trecho[index], 'P')
														verificaAeroporto(index, form.trecho[index])
														$emit('trecho-alterado')
														$emit('desbloquear-pouso', item)
													}
												"
												show-disabled
												:items="item.rotaer_partida"
												:label="(rotaer) => `${rotaer.sigla} (${rotaer.local})`"
												:active="
													(rotaer) => rotaer.id == item.designativo_partida.id
												"
												:filter-disabled="
													(rotaer) => rotaer && rotaer.desativado == '1'
												"
												v-if="!item.loadAeroportoPartida"
											/>
											<flCarregando
												v-show="item.loadAeroportoPartida"
											></flCarregando>
											<p
												class="help-block"
												v-if="item.erro_designativo_partida != ''"
											>
												{{ item.erro_designativo_partida }}
											</p>
										</div>
									</div>

									<div class="row">
										<!-- LATITUDE -->
										<div
											class="col-xs-6 col-lg-6 form-group"
											:class="{
												'has-error': item.erro_lat_partida
											}"
										>
											<label>* {{ _traducao('global', 'latitude') }}:</label>
											<input
												type="text"
												v-model="item.lat_partida"
												:disabled="disabled"
												v-mask="'S00º00\'00'"
												placeholder="DGGºMM'SS"
												@blur="validaTamanhoTrecho(index, 'lat_partida', 9)"
												class="form-control input-sm"
											/>
											<p class="help-block" v-show="item.erro_lat_partida">
												{{ item.erro_lat_partida }}
											</p>
										</div>

										<!-- LONGITUDE -->
										<div
											class="col-xs-6 col-lg-6 form-group"
											:class="{
												'has-error':
													'erro_lng_partida' in item &&
													item.erro_lng_partida != ''
											}"
										>
											<label>* {{ _traducao('global', 'longitude') }}:</label>
											<input
												type="text"
												v-model="item.lng_partida"
												:disabled="disabled"
												v-mask="'S000º00\'00'"
												placeholder="DGGGºMM'SS"
												@blur="validaTamanhoTrecho(index, 'lng_partida', 10)"
												class="form-control input-sm"
											/>
											<p
												class="help-block"
												v-show="
													'erro_lng_partida' in item &&
													item.erro_lng_partida != ''
												"
											>
												{{ item.erro_lng_partida }}
											</p>
										</div>

										<!-- DECOLAGEM -->
										<div
											class="col-xs-12 col-md-6 form-group"
											:class="{'has-error': item.erro_decolagem != ''}"
										>
											<label>
												<span class="no-print">*</span>
												{{ _traducao('global', 'decolagem') }} ({{
													_traducao('global', 'previsao')
												}})
												<span v-if="trechoSolicitacao == 'basico'"
													>(UTC <span>{{ horario_db }}</span
													>):</span
												>
												<span
													v-else-if="
														trechoSolicitacao == 'avancado' &&
														flagFuso == 'sistema'
													"
													>(UTC {{ _fusoHorario }}):</span
												>
												<span
													v-else-if="
														trechoSolicitacao == 'avancado' &&
														flagFuso == 'variavel'
													"
													>(Local Origem):</span
												>
												<span v-else>(UTC)</span>
											</label>
											<div class="row">
												<div class="col-lg-7 col-xs-6" v-if="!somenteHora">
													<flDateTime
														@v-model="
															(val) => {
																item.decolagem_partida = val
																calculaDataUTC(index, 'P')
																$emit('atualiza-horario', item)
															}
														"
														:disabled="disabled"
														:value="item.decolagem_partida"
														:lang="_getLangDp"
														:placeholder="_formatDate"
														name="teste"
														:format="_formatDate"
													/>
												</div>

												<div class="col-lg-5 col-xs-6">
													<flDateTime
														@v-model="
															(val) => {
																item.decolagem_partida_hora = val
																calculaDataUTC(index, 'P')
																$emit('atualiza-horario', item)
															}
														"
														:disabled="disabled"
														:value="item.decolagem_partida_hora"
														:lang="_getLangDp"
														:min-date="minDate(index, 'decolagem_partida_hora')"
														name="teste"
														:format="'HH:mm'"
													/>
												</div>
											</div>
											<p class="help-block" v-show="item.erro_decolagem != ''">
												{{ item.erro_decolagem }}
											</p>
										</div>

										<!-- FUSO -->
										<div class="col-xs-12 col-md-2" v-if="flagAvancado">
											<label> {{ _traducao('global', 'fuso') }} :</label>
											<input
												v-if="flagFuso == 'sistema'"
												type="text"
												disabled
												class="form-control input-sm"
												:placeholder="diferenca_utc"
											/>
											<input
												v-else
												type="text"
												disabled
												class="form-control input-sm"
												v-model="item.fuso_partida"
											/>
										</div>

										<!-- DECOLAGEM -->
										<div class="col-xs-12 col-md-4" v-if="flagAvancado">
											<label>{{ _traducao('global', 'decolagem') }} (UTC):</label>
											<input
												v-if="!somenteHora"
												type="text"
												disabled
												class="form-control input-sm"
												v-model="item.decolagem_utc_partida"
											/>
											<input
												v-if="somenteHora"
												type="time"
												disabled
												class="form-control input-sm"
												v-model="item.horario_partida_previsto_utc"
											/>
										</div>
									</div>
								</div>
							</div>

							<div class="col-xs-12 col-md-6">
								<div
									v-if="_escondeMobile()"
									style="
										position: absolute;
										top: 165px;
										left: -8px;
										font-size: 20px;
									"
								>
									<i
										class="fa fa-arrow-right"
										style="color: #2196f3"
										aria-hidden="true"
									></i>
								</div>

								<div class="trecho-borda" style="min-height: 350px">
									<div class="text-center" style="margin-bottom: 20px">
										<p>
											{{
												_traducao('menuSolicitaApoio', 'destino').toUpperCase()
											}}
										</p>
									</div>
									<div class="row">
										<!-- PAÍS -->
										<div
											v-show="flagAvancado"
											class="col-xs-12 form-group"
											:class="{'has-error': item.erro_pais_destino != ''}"
										>
											<label>* {{  _traducao('global', 'pais') }} :</label>
											<v-select
												v-show="listaPaises.length"
												class="form-control input-sm"
												:options="listaPaises"
												label="descricao"
												v-model="item.pais_destino"
												:disabled="disabled"
												@input="
													carregaEstados(item, index, 'D', item.pais_destino)
													$emit('trecho-alterado')
												"
											></v-select>
											<flCarregando v-show="!listaPaises.length"></flCarregando>
											<p class="help-block" v-if="item.erro_pais_destino != ''">
												{{ item.erro_pais_destino }}
											</p>
										</div>

										<!-- ESTADO -->
										<div
											class="col-xs-12 col-md-6 form-group"
											:class="{'has-error': item.erro_estado_destino != ''}"
										>
											<label>
												<span>*</span>
												{{ _traducao('global', 'estado') }}:
											</label>
											<v-select
												:options="item.lista_estados_destino"
												label="nome"
												class="form-control input-sm"
												v-model="item.estado_destino"
												:disabled="disabled"
												@input="
													carregaCidades(item, index, 'D', item.estado_destino)
													$emit('trecho-alterado')
												"
												v-show="!item.loadEstadoDestino"
											></v-select>
											<p
												class="help-block"
												v-show="item.erro_estado_destino != ''"
											>
												{{ item.erro_estado_destino }}
											</p>
											<flCarregando
												v-show="item.loadEstadoDestino"
											></flCarregando>
										</div>

										<!-- CIDADE -->
										<div
											class="col-xs-12 col-md-6 form-group"
											:class="{'has-error': item.erro_cidade_destino != ''}"
										>
											<label>
												<span>*</span>
												{{ _traducao('global', 'cidade') }}:
											</label>
											<v-select
												:options="item.lista_cidades_destino"
												label="descricao"
												class="form-control input-sm"
												v-model="item.cidade_destino"
												:disabled="disabled"
												@input="
													carregaAeroporto(
														item,
														index,
														'D',
														item.cidade_destino
													)
													$emit('trecho-alterado')
												"
												v-show="!item.loadCidadeDestino"
											></v-select>
											<p
												class="help-block"
												v-show="item.erro_cidade_destino != ''"
											>
												{{ item.erro_cidade_destino }}
											</p>
											<flCarregando
												v-show="item.loadCidadeDestino"
											></flCarregando>
										</div>
									</div>

									<!-- Não tenho um aeródromo definido -->
									<div class="row">
										<div
											class="col-xs-12"
											:class="{'no-print': !item.nao_tem_aerodromo}"
										>
											<div
												class="checkbox solicitacao-aerodromo"
												style="margin-bottom: 6px; margin-top: 6px"
											>
												<label>
													<input
														type="checkbox"
														style="margin-top: 2px"
														v-model="item.nao_tem_aerodromo"
														:disabled="disabled"
														@change="alterarAerodromo(item, index)"
													/>
													{{
														_traducao('global', 'naoTenhoUmAerodromoDefinido')
													}}
												</label>
											</div>
										</div>
									</div>

									<div class="row" v-show="!item.nao_tem_aerodromo">
										<!-- DESIGNATIVO -->
										<div
											class="col-xs-12 form-group"
											:class="{
												'has-error': item.erro_designativo_destino != ''
											}"
										>
											<label>* {{ _traducao('global', 'aeroporto') }}:</label>
											<select-items
												@select="
													(rotaer) => {
														item.designativo_destino = rotaer ? rotaer : null
														calculaFuso(index, form.trecho[index], 'D')
														verificaAeroporto(index, form.trecho[index])
														$emit('trecho-alterado')
														$emit('desbloquear-pouso', item)
													}
												"
												show-disabled
												:items="item.rotaer_destino"
												:label="(rotaer) => `${rotaer.sigla} (${rotaer.local})`"
												:active="
													(rotaer) => rotaer.id == item.designativo_destino.id
												"
												:filter-disabled="
													(rotaer) => rotaer && rotaer.desativado == '1'
												"
												v-if="!item.loadAeroportoDestino"
											/>
											<flCarregando
												v-show="item.loadAeroportoDestino"
											></flCarregando>
											<p
												class="help-block"
												v-if="item.erro_designativo_destino != ''"
											>
												{{ item.erro_designativo_destino }}
											</p>
										</div>
									</div>

									<div class="row">
										<!-- LATITUDE -->
										<div
											class="col-xs-6 col-lg-6 form-group"
											:class="{
												'has-error':
													'erro_lat_destino' in item &&
													item.erro_lat_destino != ''
											}"
										>
											<label>* {{ _traducao('global', 'latitude') }}:</label>
											<input
												type="text"
												v-model="item.lat_destino"
												:disabled="disabled"
												v-mask="'S00º00\'00'"
												@blur="validaTamanhoTrecho(index, 'lat_destino', 9)"
												@change="limparFuso(index, 'D')"
												placeholder="DGGºMM'SS"
												class="form-control input-sm"
											/>
											<p
												class="help-block"
												v-show="
													'erro_lat_destino' in item &&
													item.erro_lat_destino != ''
												"
											>
												{{ item.erro_lat_destino }}
											</p>
										</div>

										<!-- LONGITUDE -->
										<div
											class="col-xs-6 col-lg-6 form-group"
											:class="{
												'has-error':
													'erro_lng_destino' in item &&
													item.erro_lng_destino != ''
											}"
										>
											<label>* {{ _traducao('global', 'longitude') }}:</label>
											<input
												type="text"
												v-model="item.lng_destino"
												:disabled="disabled"
												v-mask="'S000º00\'00'"
												@blur="validaTamanhoTrecho(index, 'lng_destino', 10)"
												@change="limparFuso(index, 'D')"
												placeholder="DGGGºMM'SS"
												class="form-control input-sm"
											/>
											<p
												class="help-block"
												v-show="
													'erro_lng_destino' in item &&
													item.erro_lng_destino != ''
												"
											>
												{{ item.erro_lng_destino }}
											</p>
										</div>

										<div
											v-if="flagAvancado"
											class="col-xs-6 col-md-2 form-group"
											:class="{'has-error': item.erro_adicional != ''}"
										>
											<label> {{  _traducao('global', 'adicional') }} </label>
											<br />
											<flSimNao v-model="item.adicional" :disabled="disabled" />
											<p class="help-block" v-show="item.erro_adicional != ''">
												{{ item.erro_adicional }}
											</p>
										</div>

										<div
											v-if="flagAvancado"
											class="col-xs-6 col-md-2 form-group"
											:class="{'has-error': item.erro_pernoite != ''}"
										>
											<label> {{ _traducao('global', 'pernoite') }} </label>
											<br />
											<flSimNao v-model="item.pernoite" :disabled="disabled" />
											<p class="help-block" v-show="item.erro_pernoite != ''">
												{{ item.erro_pernoite }}
											</p>
										</div>
									</div>

									<div
										class="row"
										v-show="item.nao_tem_aerodromo"
										:class="{'has-error': item.erro_descricao_destino != ''}"
										style="margin-top: -10px"
									>
										<div class="col-xs-12 print-recuo-10">
											<label>
												<span>*</span>
												{{ _traducao('global', 'descricaoDoLocal') }}:
											</label>
											<textarea
												v-model="item.descricao_destino"
												@keyup="validaDescricaoDestino(index)"
												:disabled="disabled"
												class="form-control input-sm"
												rows="2"
											></textarea>
											<p
												class="help-block"
												v-show="item.erro_descricao_destino != ''"
											>
												{{ item.erro_descricao_destino }}
											</p>
											<small
												:class="{
													'text-danger':
														100 - item.descricao_destino.length <= 0
												}"
												class="text-info pull-right"
											>
												{{ 100 - item.descricao_destino.length }}
												{{ _traducao('global', 'caracteresRestantes') }}
											</small>
										</div>
									</div>

									<div class="row" v-if="flagAvancado">
										<div
											class="col-xs-12 col-md-6 form-group"
											:class="{'has-error': item.erro_pouso_previsto != ''}"
										>
											<label>*  {{ _traducao('global', 'pousoPrevisto') }} :</label
											><small>
												<span
													v-if="
														trechoSolicitacao == 'avancado' &&
														flagFuso == 'sistema'
													"
												></span>
												<span
													v-if="
														trechoSolicitacao == 'avancado' &&
														flagFuso == 'variavel'
													"
													>(Local Destino):</span
												>
												<span
													v-if="
														trechoSolicitacao == 'avancado' && flagFuso == 'UTC'
													"
													>(UTC):</span
												></small
											>
											<div class="row">
												<div class="col-lg-7 col-xs-6" v-if="!somenteHora">
													<flDateTime
														@v-model="
															(val) => {
																item.pouso_previsto = val
																calculaDataUTC(index, 'D')
																$emit('atualiza-horario', item)
															}
														"
														:disabled="disabled"
														:value="item.pouso_previsto"
														:lang="_getLangDp"
														:placeholder="_formatDate"
														name="teste"
														:format="_formatDate"
													/>
												</div>

												<div class="col-lg-5 col-xs-6">
													<flDateTime
														@v-model="
															(val) => {
																item.pouso_previsto_hora = val
																calculaDataUTC(index, 'D')
																$emit('atualiza-horario', item)
															}
														"
														:disabled="disabled"
														:value="item.pouso_previsto_hora"
														:lang="_getLangDp"
														:min-date="minDate(index, 'pouso_previsto_hora')"
														name="teste"
														:format="'HH:mm'"
													/>
												</div>
											</div>
											<p
												class="help-block"
												v-if="item.erro_pouso_previsto != ''"
											>
												{{ item.erro_pouso_previsto }}
											</p>
										</div>
										<!-- FUSO -->
										<div class="col-xs-12 col-md-2">
											<label> {{ _traducao('global', 'fuso') }} :</label>
											<input
												v-if="flagFuso && flagFuso === 'sistema'"
												type="text"
												disabled
												class="form-control input-sm"
												:placeholder="diferenca_utc"
											/>
											<input
												v-else
												type="text"
												disabled
												class="form-control input-sm"
												v-model="item.fuso_destino"
											/>
										</div>

										<!-- DECOLAGEM -->
										<div class="col-xs-12 col-md-4">
											<label> {{ _traducao('global', 'pouso') }}  (UTC):</label>
											<input
												v-if="!somenteHora"
												type="text"
												disabled
												class="form-control input-sm"
												v-model="item.pouso_previsto_utc"
											/>
											<input
												v-if="somenteHora"
												type="time"
												disabled
												class="form-control input-sm"
												v-model="item.horario_pouso_previsto_utc"
											/>
										</div>
									</div>
									<div class="row" v-if="!flagAvancado && pousoPrevisto">
										<div
											class="col-xs-12 col-md-6 form-group"
											:class="{'has-error': item.erro_pouso_previsto != ''}"
										>
											<label>*  {{ _traducao('global', 'pousoPrevisto') }} :</label>
											<div class="row">
												<div class="col-lg-7 col-xs-6" v-if="!somenteHora">
													<flDateTime
														@v-model="
															(val) => {
																item.pouso_previsto = val
																$emit('atualiza-horario', item)
															}
														"
														:disabled="disabled || item.disableDataPouso"
														:value="item.pouso_previsto"
														:lang="_getLangDp"
														:placeholder="_formatDate"
														name="teste"
														:format="_formatDate"
													/>
												</div>

												<div class="col-lg-5 col-xs-6">
													<flDateTime
														@v-model="
															(val) => {
																item.pouso_previsto_hora = val
																calculaDataUTC(index, 'D')
																$emit('atualiza-horario', item)
															}
														"
														:disabled="disabled || item.disableDataPouso"
														:value="item.pouso_previsto_hora"
														:lang="_getLangDp"
														:min-date="minDate(index, 'pouso_previsto_hora')"
														name="teste"
														:format="'HH:mm'"
													/>
												</div>
											</div>
											<p
												class="help-block"
												v-if="item.erro_pouso_previsto != ''"
											>
												{{ item.erro_pouso_previsto }}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12" v-if="trechoMultiplo">
			<Divider />
			<ButtonNew :disabled="disabled" @click="clickTrechoAdd()">{{
				_traducao('global', 'novoTrecho').toUpperCase()
			}}</ButtonNew>
			<ButtonShare
				v-if="form.trecho.length > 1 && _getPrivilegio(408) && planejarRotas"
				@click="redirectToRoutes"
				>PLANEJAR TODAS ROTAS</ButtonShare
			>
		</div>
	</div>
</template>

<script>
import LZString from 'lz-string'
import trechoFactory from '@/factories/solicitacao/editando'
import mixin from './mixin'
import moment from 'moment'
export default {
	props: {
		form: Object,
		disabled: Boolean,
		trechoMultiplo: {
			type: Boolean,
			default: true
		},
		apenasExibicao: {
			type: Boolean,
			default: false
		},
		pousoPrevisto: {
			type: [Boolean, String],
			default: false
		},
		somenteHora: {
			type: [Boolean, String],
			default: false
		},
		bloqueaPouso: {
			type: [Boolean, String],
			default: false
		},
		mudarCabecalho: {
			type: [Boolean, String],
			default: false
		},
		planejarRotas: {
			type: Boolean,
			default: false
		}
	},
	mixins: [mixin],
	data() {
		return {
			listaPaises: [],
			rotaER: [],
			flagComponente: $cliente.get('componente_trecho_solicitacao'),
			flagFuso: $cliente.get('fuso_trecho'),
			ano: new Date().getFullYear(),
			trechoSolicitacao: '',
			diferenca_utc: '',
			horario_db: ''
		}
	},
	computed: {
		flagAvancado() {
			bus.$emit('flagAvancado', this.flagComponente === 'avancado')
			return this.flagComponente === 'avancado'
		}
	},
	created() {
		this._providerRotaer((lista) => {
			this.rotaER = lista
			bus.$emit('load-out')
		})
		this.carregaPaises()

		this.trechoSolicitacao = $cliente.get('componente_trecho_solicitacao')
		this.diferenca_utc = parseInt(this._fusoHorario, 10)
		this.horario_db = $cliente.get('horario_db')
	},

	methods: {
		getWaypointPartida(item) {
			if (item.designativo_partida.waypoint) {
				return {
					name: item.designativo_partida.sigla,
					waypoint: item.designativo_partida.waypoint
				}
			} else if (item.lat_partida && item.lng_partida) {
				const waypoint = JSON.stringify({
					name: item.designativo_partida.sigla,
					lat: this._convertDD(item.lat_partida, 'lat'),
					lng: this._convertDD(item.lng_partida, 'lng')
				})
				return {
					name: item.designativo_partida.sigla,
					waypoint
				}
			}
		},
		getWaypointDestino(item) {
			if (item.designativo_destino.waypoint) {
				return {
					name: item.designativo_destino.sigla,
					waypoint: item.designativo_destino.waypoint
				}
			} else if (item.lat_destino && item.lng_destino) {
				const name = item.nao_tem_aerodromo
					? item.descricao_destino
					: item.designativo_destino.sigla
				const waypoint = JSON.stringify({
					name,
					lat: this._convertDD(item.lat_destino, 'lat'),
					lng: this._convertDD(item.lng_destino, 'lng')
				})
				return {
					name,
					waypoint
				}
			}
		},
		redirectTo(waypoints, names) {
			const route = waypoints.join('|')
			const routeStringEncoded = LZString.compressToEncodedURIComponent(
				route.replace(/\+/g, '.')
			)
			const namesString = names.join(' - ')
			const link = `https://share.nexatlas.com/route?route=${routeStringEncoded}&name=${namesString}&sender=Aerohouse&charts=WAC%7CREH`
			window.open(link, '_blank')
		},
		redirectToRoute(item) {
			const routeWaypoints = []
			const names = []

			const partida = this.getWaypointPartida(item)
			if (partida) {
				names.push(partida.name)
				routeWaypoints.push(partida.waypoint)
			}

			const destino = this.getWaypointDestino(item)
			if (destino) {
				names.push(destino.name)
				routeWaypoints.push(destino.waypoint)
			}

			this.redirectTo(routeWaypoints, names)
		},
		redirectToRoutes() {
			const routeWaypoints = []
			const names = []

			this.form.trecho.forEach((item) => {
				const partida = this.getWaypointPartida(item)
				if (partida) {
					names.push(partida.name)
					routeWaypoints.push(partida.waypoint)
				}

				const destino = this.getWaypointDestino(item)
				if (destino) {
					names.push(destino.name)
					routeWaypoints.push(destino.waypoint)
				}
			})

			this.redirectTo(routeWaypoints, names)
		},
		filterSelect(options, search) {
			return options.filter(
				({local, sigla}) =>
					local.toLowerCase().includes(search.toLowerCase()) ||
					sigla.toLowerCase().includes(search.toLowerCase())
			)
		},
		minDate(index, campo) {
			return index && !isNaN(this.form.trecho[index - 1][campo])
				? this.form.trecho[index - 1][campo]
				: ''
		},
		disabledDownButton(indexTrecho) {
			if (this.form.trecho.length - 1 == indexTrecho) {
				return true
			} else {
				return false
			}
		},

		// move um item na lista para cima ou baixo
		clickMove(tipo, item, indexTrecho) {
			let indexTroca = 0
			if (tipo == 'up') {
				indexTroca = indexTrecho + 1
			}

			if (tipo == 'down') {
				indexTroca = indexTrecho - 1
			}
			let aux = this.form.trecho[indexTroca]
			this.form.trecho[indexTroca] = item

			this.form.trecho[indexTrecho] = aux

			this.$forceUpdate()
			this.$emit('trecho-atualizado')
		},
		// NO DESTINO AO MARCAR `NÃO TENHO UM AERODROMO` VERIFICA E VALIDA O DESGINATIVO DE DESTINO
		alterarAerodromo(item, index) {
			this.form.trecho[index].descricao_destino = ''
			if (item.nao_tem_aerodromo == false) {
				this.setaLatLong(index, item, 'D')
				this.form.trecho[index].disableDataPouso = true
			} else {
				this.form.trecho[index].disableDataPouso = false
				this.form.trecho[index].lat_destino = ''
				this.form.trecho[index].lng_destino = ''
				this.form.trecho[index].designativo_destino = ''
			}
		},

		clickTrechoRemover(index) {
			this.form.trecho.splice(index, 1)
			this.form.trecho.map((trecho, index) => {
				trecho.trecho = index + 1
			})
			this.$emit('remove-trecho', index)
		},

		clickTrechoAdd() {
			const trecho = trechoFactory.createProximoTrecho(
				this.form.trecho[this.form.trecho.length - 1]
			)
			this.form.trecho.push(trecho)
			this.form.trecho.map((trecho, index) => {
				trecho.trecho = index + 1
			})
			this.$emit('adiciona-trecho', trecho)
		},

		// VALIDA A QUANTIDADE DE TEXTO DIGITADA
		validaDescricaoDestino(index) {
			this.form.trecho[index].erro_descricao_destino = ''
			var sub = 100 - this.form.trecho[index].descricao_destino.length
			if (sub <= 0) {
				this.form.trecho[index].descricao_destino = this.form.trecho[
					index
				].descricao_destino.substring(
					0,
					this.form.trecho[index].descricao_destino.length - Math.abs(sub)
				)
			}
			return true
		},

		setaLatLong(index, item, tipo) {
			if (tipo === 'P') {
				if (item.designativo_partida.sigla === 'ZZZZ') {
					if (item.designativo_partida.grau_lat) {
						this.form.trecho[index].lat_partida =
							item.designativo_partida.grau_lat
					} else {
						this.form.trecho[index].lat_partida =
							item.designativo_partida.latitude != null
								? this._convertDMS(
										item.designativo_partida.latitude,
										item.designativo_partida.longitude
								  ).lat
								: item.lat_partida
					}
					if (item.designativo_partida.grau_lng) {
						this.form.trecho[index].lng_partida =
							item.designativo_partida.grau_lng
					} else {
						this.form.trecho[index].lng_partida =
							item.designativo_partida.longitude != null
								? this._convertDMS(
										item.designativo_partida.latitude,
										item.designativo_partida.longitude
								  ).lng
								: item.lng_partida
					}

					this.form.trecho[index].rotaer_local_partida =
						this.form.trecho[index].rotaer_local_partida ?? ''
					this.form.trecho[index].descricao_partida =
						this.form.trecho[index].descricao_partida ?? ''
				} else {
					if (item.designativo_partida !== '') {
						this.form.trecho[index].lat_partida = this._convertDMS(
							item.designativo_partida.latitude,
							item.designativo_partida.longitude
						).lat
						this.form.trecho[index].lng_partida = this._convertDMS(
							item.designativo_partida.latitude,
							item.designativo_partida.longitude
						).lng
					} else {
						this.form.trecho[index].lat_partida = ''
						this.form.trecho[index].lng_partida = ''
					}
				}
			}
			if (tipo === 'D') {
				if (item.designativo_destino.sigla === 'ZZZZ') {
					if (item.designativo_destino.grau_lat) {
						this.form.trecho[index].lat_destino =
							item.designativo_destino.grau_lat
					} else {
						this.form.trecho[index].lat_destino =
							item.designativo_destino.latitude != null
								? this._convertDMS(
										item.designativo_destino.latitude,
										item.designativo_destino.longitude
								  ).lat
								: item.lat_destino
					}
					if (item.designativo_destino.grau_lng) {
						this.form.trecho[index].lng_destino =
							item.designativo_destino.grau_lng
					} else {
						this.form.trecho[index].lng_destino =
							item.designativo_destino.longitude != null
								? this._convertDMS(
										item.designativo_destino.latitude,
										item.designativo_destino.longitude
								  ).lng
								: item.lng_destino
					}
					this.form.trecho[index].lat_destino =
						this.form.trecho[index].lat_destino ?? ''
					this.form.trecho[index].lng_destino =
						this.form.trecho[index].lng_destino ?? ''
					this.form.trecho[index].rotaer_local_destino =
						this.form.trecho[index].rotaer_local_destino ?? ''
					this.form.trecho[index].descricao_destino =
						this.form.trecho[index].descricao_destino ?? ''
				} else if (!item.nao_tem_aerodromo) {
					if (item.designativo_destino !== '') {
						this.form.trecho[index].lat_destino = this._convertDMS(
							item.designativo_destino.latitude,
							item.designativo_destino.longitude
						).lat
						this.form.trecho[index].lng_destino = this._convertDMS(
							item.designativo_destino.latitude,
							item.designativo_destino.longitude
						).lng
					} else {
						if (!item.nao_tem_aerodromo) {
							this.form.trecho[index].lat_destino = ''
							this.form.trecho[index].lng_destino = ''
						}
					}
				}
			}
		},

		limparFuso(index, tipo) {
			let utc = ''
			let fuso = ''

			if (tipo == 'D') {
				fuso = 'fuso_destino'
				utc = 'pouso_previsto_utc'
			} else {
				fuso = 'fuso_partida'
				utc = 'decolagem_utc_partida'
			}

			this.form.trecho[index][fuso] = ''
			this.form.trecho[index][utc] = ''

			this.calculaDataUTC(index, tipo)
		},

		calculaFuso(index, item, tipo) {
			this.setaLatLong(index, item, tipo)
			let utc = ''
			let data = ''
			let designativo = ''
			let fuso = ''
			let latitude = ''
			let longitude = ''

			if (tipo == 'D') {
				fuso = 'fuso_destino'
				utc = 'pouso_previsto_utc'
				data = 'pouso_previsto_hora'
				designativo = item['designativo_destino']
			} else {
				fuso = 'fuso_partida'
				utc = 'decolagem_utc_partida'
				data = 'decolagem_partida_hora'
				designativo = item['designativo_partida']
			}
			if (designativo !== '') {
				latitude = designativo.latitude
				longitude = designativo.longitude
			} else if (
				item.nao_tem_aerodromo &&
				tipo === 'D' &&
				item.lat_destino != '' &&
				item.lng_destino != ''
			) {
				latitude = this._convertDD(item.lat_destino, 'lat')
				longitude = this._convertDD(item.lng_destino, 'lng')
			}
			if (
				data !== '' &&
				latitude !== '' &&
				longitude !== '' &&
				latitude &&
				longitude
			) {
				this._googleTimeZone(
					latitude,
					longitude,
					this.getDecolageGoogleTimeZone(item[data])
				).then((timezone) => {
					if (!window._.isNil(timezone.rawOffset)) {
						if (this.flagFuso === 'variavel') {
							this.form.trecho[index][fuso] =
								(timezone.dstOffset + timezone.rawOffset) / 3600
						} else if (this.flagFuso === 'UTC') {
							this.form.trecho[index][fuso] = 0
						} else {
							this.form.trecho[index][fuso] = Number(this.diferenca_utc)
						}
						this.calculaDataUTC(index, tipo)
					}
					if (timezone.status === 'ZERO_RESULTS') {
						this.form.trecho[index][fuso] = 0
						this.form.trecho[index][utc] = this.form.trecho[index][data]
					}
					if (timezone.dstOffset + timezone.rawOffset === 0) {
						this.form.trecho[index][fuso] = 0
						this.form.trecho[index][utc] = this.form.trecho[index][data]
					}
				})
			}
		},

		validaTamanhoTrecho(index, campo, leng) {
			this.$nextTick(() => {
				switch (campo) {
					case 'lat_partida':
						if (this.form.trecho[index].lat_partida.length === leng) {
							this.form.trecho[index].erro_len_lat_partida = false
						} else {
							this.form.trecho[index].erro_len_lat_partida = true
							this.$forceUpdate()
						}
						break
					case 'lng_partida':
						if (this.form.trecho[index].lng_partida.length === leng) {
							this.form.trecho[index].erro_len_lng_partida = false
						} else {
							this.form.trecho[index].erro_len_lng_partida = true
							this.$forceUpdate()
						}
						break
					case 'lat_destino':
						if (this.form.trecho[index].lat_destino.length === leng) {
							this.form.trecho[index].erro_len_lat_destino = false
						} else {
							this.form.trecho[index].erro_len_lat_destino = true
							this.$forceUpdate()
						}
						break
					case 'lng_destino':
						if (this.form.trecho[index].lng_destino.length === leng) {
							this.form.trecho[index].erro_len_lng_destino = false
						} else {
							this.form.trecho[index].erro_len_lng_destino = true
							//this.$forceUpdate()
						}
						break
				}
			})
		},
		getDecolageGoogleTimeZone(horaDecolagem) {
			return window.moment(horaDecolagem, 'HH:mm').format('DD/MM/YYYY HH:mm')
		},
		getDataDecolagemGoogleTimeZone(dataString) {
			const data = window.moment(dataString, 'DD/MM/YYYY HH:mm')
			if (data.isValid()) {
				return data
			}
			return false
		},
		calculaDataUTC(index, tipo) {
			let fuso = ''
			let utc = ''
			let horario_previsto_utc = ''
			let data = ''
			let dataString = ''
			if (tipo == 'D') {
				fuso = 'fuso_destino'
				utc = 'pouso_previsto_utc'
				horario_previsto_utc = 'horario_pouso_previsto_utc'
				data = 'pouso_previsto_hora'
				if (
					this.form.trecho[index].pouso_previsto &&
					this.form.trecho[index].pouso_previsto_hora
				) {
					dataString = `${this.form.trecho[index].pouso_previsto} ${this.form.trecho[index].pouso_previsto_hora}`
				}
			} else {
				fuso = 'fuso_partida'
				utc = 'decolagem_utc_partida'
				horario_previsto_utc = 'horario_partida_previsto_utc'
				data = 'decolagem_partida_hora'
				if (
					this.form.trecho[index].decolagem_partida &&
					this.form.trecho[index].decolagem_partida_hora
				) {
					dataString = `${this.form.trecho[index].decolagem_partida} ${this.form.trecho[index].decolagem_partida_hora}`
				}
			}
			if (this.form.trecho[index][fuso] === '') {
				this.calculaFuso(index, this.form.trecho[index], tipo)
			} else {
				if (!this.somenteHora) {
					let novaDataUtc = this.getDataDecolagemGoogleTimeZone(dataString)
					if (novaDataUtc) {
						let fusoHora = this.form.trecho[index][fuso] * -1
						if (fusoHora < 0) {
							novaDataUtc = novaDataUtc.subtract(fusoHora, 'hours')
						} else {
							novaDataUtc = novaDataUtc.add(fusoHora, 'hours')
						}
						this.form.trecho[index][utc] =
							novaDataUtc.format('DD/MM/YYYY HH:mm')
						this.form.trecho[index][horario_previsto_utc] =
							novaDataUtc.format('HH:mm')
					}
				} else {
					let novaDataUtc = moment(
						`${moment().format('DD/MM/YYYY')} ${this.form.trecho[index][data]}`,
						'DD/MM/YYYY HH:mm'
					)
					let fusoHora = this.form.trecho[index][fuso] * -1
					if (fusoHora < 0) {
						novaDataUtc = novaDataUtc.subtract(fusoHora, 'hours')
					} else {
						novaDataUtc = novaDataUtc.add(fusoHora, 'hours')
					}
					this.form.trecho[index][horario_previsto_utc] =
						novaDataUtc.format('HH:mm')
				}
			}
			this.$forceUpdate()
		},
		carregaEstados(item, index, tipo, pais) {
			if (!pais) return false
			if (tipo === 'P') {
				if (
					!item.partidaEditando?.editando.pais &&
					this.form.trecho[index].id_pais_partida != item.pais_partida.codigo
				) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(
						this.form.trecho[index],
						'P',
						3
					)
					this.form.trecho[index].pais_partida = item.pais_partida
					this.form.trecho[index].id_pais_partida = item.pais_partida.codigo
				} else {
					item.partidaEditando.editando.pais = false
				}
				if (!!this.form.trecho[index].pais_partida.nome) {
					this.form.trecho[index].loadEstadoPartida = true
					this.requests(
						'pais',
						this._removerAcentos(this.form.trecho[index].pais_partida.nome)
					).then((response) => {
						this.form.trecho[index].lista_estados_partida = response
						this.form.trecho[index].loadEstadoPartida = false
					})
				}
			}
			if (tipo === 'D') {
				if (
					!item.destinoEditando?.editando.pais &&
					this.form.trecho[index].id_pais_destino != item.pais_destino.codigo
				) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(
						this.form.trecho[index],
						'D',
						3
					)
					this.form.trecho[index].pais_destino = item.pais_destino
					this.form.trecho[index].id_pais_destino = item.pais_destino.codigo
				} else {
					item.destinoEditando.editando.pais = false
				}
				if (!!this.form.trecho[index].pais_destino.nome) {
					this.form.trecho[index].loadEstadoDestino = true
					this.requests(
						'pais',
						this._removerAcentos(this.form.trecho[index].pais_destino.nome)
					).then((response) => {
						this.form.trecho[index].lista_estados_destino = response
						this.form.trecho[index].loadEstadoDestino = false
					})
				}
			}
		},
		carregaCidades(item, index, tipo, estado) {
			if (!estado) return false
			if (tipo === 'P') {
				if (
					!item.partidaEditando?.editando.estado &&
					this.form.trecho[index].id_estado_partida != item.estado_partida.id &&
					this.form.aeroportoFavorito == null
				) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(
						this.form.trecho[index],
						'P',
						2
					)
					this.form.trecho[index].nome_estado_partida = item.estado_partida.nome
					this.form.trecho[index].estado_partida = item.estado_partida
					this.form.trecho[index].id_estado_partida = item.estado_partida.id
				} else {
					item.partidaEditando.editando.estado = false
				}
				if (!!this.form.trecho[index].estado_partida.nome) {
					this.form.trecho[index].loadCidadePartida = true
					this.requests(
						'province',
						this.form.trecho[index].estado_partida.id
					).then((response) => {
						this.form.trecho[index].lista_cidades_partida = response
						this.form.trecho[index].loadCidadePartida = false
					})
				}
			}
			if (tipo === 'D') {
				if (
					!item.destinoEditando?.editando.estado &&
					this.form.trecho[index].id_estado_destino != item.estado_destino.id
				) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(
						this.form.trecho[index],
						'D',
						2
					)
					this.form.trecho[index].nome_estado_destino = item.estado_destino.nome
					this.form.trecho[index].estado_destino = item.estado_destino
					this.form.trecho[index].id_estado_destino = item.estado_destino.id
				} else {
					item.destinoEditando.editando.estado = false
				}
				if (!!this.form.trecho[index].estado_destino.nome) {
					this.form.trecho[index].loadCidadeDestino = true
					this.requests(
						'province',
						this.form.trecho[index].estado_destino.id
					).then((response) => {
						this.form.trecho[index].lista_cidades_destino = response
						this.form.trecho[index].loadCidadeDestino = false
					})
				}
			}
		},
		carregaAeroporto(item, index, tipo, cidade) {
			if (!cidade) return false
			if (tipo === 'P') {
				if (
					!item.partidaEditando.editando.cidade &&
					this.form.trecho[index].id_cidade_partida != item.cidade_partida.id &&
					this.form.aeroportoFavorito == null
				) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(
						this.form.trecho[index],
						'P',
						1
					)
					this.form.trecho[index].nome_cidade_partida =
						item.cidade_partida.descricao
					this.form.trecho[index].cidade_partida = item.cidade_partida
					this.form.trecho[index].id_cidade_partida = item.cidade_partida.id
				} else {
					item.partidaEditando.editando.cidade = false
				}
				if (!!this.form.trecho[index].cidade_partida.descricao) {
					this.form.trecho[index].loadAeroportoPartida = true
					this.requests(
						'cidade',
						this.form.trecho[index].cidade_partida.id,
						this.form.trecho[index].cidade_partida.descricao
					).then((response) => {
						this.form.trecho[index].rotaer_partida = response
						this.form.trecho[index].loadAeroportoPartida = false
					})
				}
			}
			if (tipo === 'D') {
				if (
					!item.destinoEditando.editando.cidade &&
					this.form.trecho[index].id_cidade_destino != item.cidade_destino.id
				) {
					this.form.trecho[index] = trechoFactory.createCamposLocalidade(
						this.form.trecho[index],
						'D',
						1
					)
					this.form.trecho[index].nome_cidade_destino =
						item.cidade_destino.descricao
					this.form.trecho[index].cidade_destino = item.cidade_destino
					this.form.trecho[index].id_cidade_destino = item.cidade_destino.id
				} else {
					item.destinoEditando.editando.cidade = false
				}
				if (!!this.form.trecho[index].cidade_destino.descricao) {
					this.form.trecho[index].loadAeroportoDestino = true
					this.requests(
						'cidade',
						this.form.trecho[index].cidade_destino.id,
						this.form.trecho[index].cidade_destino.descricao
					).then((response) => {
						this.form.trecho[index].rotaer_destino = response
						this.form.trecho[index].loadAeroportoDestino = false
					})
				}
			}
		},
		verificaAeroporto(index, item) {
			if (this.form.trecho[index].designativo_partida !== '') {
				if (
					this.form.trecho[index].designativo_partida.id ===
					this.form.trecho[index].designativo_destino.id
				) {
					this.form.trecho[index].tem_pouso_previsto = true
				} else {
					this.form.trecho[index].tem_pouso_previsto = false
				}
			}
			this.$forceUpdate()
		}
	}
}
</script>